import { useState } from 'react'

const FAQ = ({question, answer}) => {
  const [isAnswerShowing, setIsAnswerShowing] = useState(false);

  return (
    <article className={`faq ${isAnswerShowing ? 'faq--open' : ''}`} onClick={() => setIsAnswerShowing(prev => !prev)}>
      <div className="faq__row">
        <h4 className="faq__question">{question}</h4>
        <span className="faq__icon">{isAnswerShowing ? '−' : '+'}</span>
      </div>
      {isAnswerShowing && <p className="faq__answer">{answer}</p>}
    </article>
  )
}

export default FAQ
